

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';

import WechatPlugin from 'vux/src/plugins/wechat/index.js'

Vue.use(WechatPlugin);

console.log("Vue.wechat", Vue.wechat) 

Vue.config.productionTip = false

window.eventBus = new Vue();

window.XGurl = "https://payback.luxark.net/h5-pay/?";

window.ReqUrl = "";

window.h5Version = "1.0.1";

/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js